window.FELD_DATA = {
    "version":  1,
    "waehrung":  "EUR",
    "grenzen":  {
                    "min_laenge_m":  0.5,
                    "max_laenge_m":  3.0,
                    "min_hoehe_cm":  60,
                    "max_hoehe_cm":  150,
                    "hoehe_schritt_cm":  5
                },
    "parameter":  {
                      "kommentar":  "Oeffentliche Datenvariante: Verkaufs-Einzelpreise (Aufschlag bereits eingerechnet).",
                      "riegel_reihen":  2,
                      "schrauben_pro_latte_riegel":  2,
                      "schrauben_preis":  0.104,
                      "schrauben_gewicht_kg":  0.005,
                      "montage_pauschale":  46.41,
                      "zuschnitt_pauschale":  0,
                      "aufschlag_pct":  0,
                      "min_gewinn":  0.0,
                      "preis_raster_eur":  10,
                      "preis_raster_kommentar":  "Shop-Preis wird auf dieses Raster AUFgerundet, damit er als Produktvariante (Varianten-Raster) abbildbar ist. 0 = exakter Preis (Mengen-Produkt-Modus).",
                      "shop_preisaufschlag_faktor":  1.14,
                      "shop_preisaufschlag_kommentar":  "Globaler Marktaufschlag des Shops (deutscher Markt +14 %). Die Varianten-CSV schreibt Basispreis = Rasterpreis / Faktor, damit der Kunde nach Aufschlag genau den im Konfigurator angezeigten Rasterpreis zahlt – gleiche Konvention wie der Cockpit-Preissync. Bei Änderung des Shop-Aufschlags: Faktor anpassen, CSV neu generieren und importieren."
                  },
    "versand":  {
                    "kommentar":  "Port von classify_shipping() aus dem Cockpit. Ab langgut_ab_cm greift unabhängig vom Gewicht der Langgut-Tarif (Speditions-Langgutzuschlag); im Shop hängt daran das Versandprofil \u0027Langgut\u0027 über das separate Langgut-Konfigurator-Produkt.",
                    "langgut_ab_cm":  240,
                    "kurz_grenze_cm":  190,
                    "mittel_grenze_cm":  240,
                    "umklassifizieren_ab_cm":  240,
                    "umklassifizieren_unter_kg":  80,
                    "ersatz_laenge_cm":  200,
                    "kurz_stufen":  [
                                        {
                                            "max_kg":  31.5,
                                            "kosten":  20.0,
                                            "art":  "Paketversand (bis 31,5 kg)"
                                        },
                                        {
                                            "max_kg":  60.0,
                                            "kosten":  40.0,
                                            "art":  "Spedition (bis 60 kg)"
                                        },
                                        {
                                            "max_kg":  90.0,
                                            "kosten":  60.0,
                                            "art":  "Spedition (bis 90 kg)"
                                        },
                                        {
                                            "max_kg":  null,
                                            "kosten":  120.0,
                                            "art":  "Spedition (ab 90 kg)"
                                        }
                                    ],
                    "mittel":  {
                                   "kosten":  120.0,
                                   "art":  "Spedition (190–240 cm)"
                               },
                    "lang":  {
                                 "kosten":  193.28,
                                 "art":  "Spedition Langgut (über 240 cm, inkl. Langgutzuschlag)"
                             }
                },
    "modelle":  [
                    {
                        "id":  "senkr_lattenzaun_2c",
                        "name":  "Senkrechter Lattenzaun 2C",
                        "material":  "Fichte KDI",
                        "beschreibung":  "Der Klassiker mit senkrechten Halbrundlatten.",
                        "latten_name":  "Senkrechter_Lattenzaun_2C",
                        "riegel_name":  "Querriegel_B",
                        "riegel_anzeige":  "Querriegel halbrund B (Fichte)",
                        "sortierung":  1,
                        "skizze":  {
                                       "kopf":  "spitz",
                                       "spitzeFaktor":  0.9,
                                       "profil":  "rund",
                                       "riegel":  "rund"
                                   }
                    },
                    {
                        "id":  "senkr_lattenzaun_3e",
                        "name":  "Senkrechter Lattenzaun 3E",
                        "material":  "Fichte KDI",
                        "beschreibung":  "Senkrechter Lattenzaun in der Ausführung 3E.",
                        "latten_name":  "Senkrechter_Lattenzaun_3E",
                        "riegel_name":  "Querriegel_B",
                        "riegel_anzeige":  "Querriegel halbrund B (Fichte)",
                        "sortierung":  2,
                        "skizze":  {
                                       "kopf":  "schraeg",
                                       "profil":  "rund",
                                       "riegel":  "rund"
                                   }
                    },
                    {
                        "id":  "quadratzaun_4k",
                        "name":  "Quadratzaun 4K",
                        "material":  "Fichte KDI",
                        "beschreibung":  "Feine, moderne Optik mit schmalen quadratischen Latten.",
                        "latten_name":  "Quadratzaun_4K",
                        "riegel_name":  "Vierkantriegel_A",
                        "riegel_anzeige":  "Vierkantriegel A (Fichte)",
                        "sortierung":  3,
                        "skizze":  {
                                       "kopf":  "flach",
                                       "profil":  "eckig",
                                       "riegel":  "flach"
                                   }
                    },
                    {
                        "id":  "quadratzaun_32a",
                        "name":  "Quadratzaun 32A (Lärche)",
                        "material":  "Lärche",
                        "beschreibung":  "Quadratzaun aus unbehandelter, von Natur aus dauerhafter Lärche.",
                        "latten_name":  "Quadratzaun_Laerche_32A",
                        "riegel_name":  "Vierkantriegel_Laerche_LV",
                        "riegel_anzeige":  "Vierkantriegel LV (Lärche)",
                        "sortierung":  4,
                        "skizze":  {
                                       "kopf":  "flach",
                                       "profil":  "eckig",
                                       "riegel":  "flach"
                                   }
                    },
                    {
                        "id":  "hobellattenzaun_12a",
                        "name":  "Hobellattenzaun 12A",
                        "material":  "Fichte KDI",
                        "beschreibung":  "Breite, gehobelte Latten für eine ruhige Optik.",
                        "latten_name":  "Hobellattenzaun_12A",
                        "riegel_name":  "Vierkantriegel_A",
                        "riegel_anzeige":  "Vierkantriegel A (Fichte)",
                        "sortierung":  5,
                        "skizze":  {
                                       "kopf":  "flach",
                                       "profil":  "eckig",
                                       "riegel":  "flach"
                                   }
                    },
                    {
                        "id":  "knueppelzaun_1r",
                        "name":  "Knüppelzaun 1R",
                        "material":  "Fichte KDI",
                        "beschreibung":  "Rustikaler Bauernzaun aus halbrunden Knüppellatten.",
                        "latten_name":  "Knueppelzaun_1R",
                        "riegel_name":  "Querriegel_B",
                        "riegel_anzeige":  "Querriegel halbrund B (Fichte)",
                        "sortierung":  6,
                        "skizze":  {
                                       "kopf":  "spitz",
                                       "spitzeFaktor":  1.2,
                                       "profil":  "rund",
                                       "riegel":  "rund"
                                   }
                    }
                ],
    "generiert_am":  "2026-07-08",
    "latten":  [
                   {
                       "name":  "Quadratzaun_4K",
                       "variante":  "4K",
                       "breite_cm":  3.5,
                       "anzahl_pro_m":  12.5,
                       "form":  "Quader",
                       "material":  "Fichte"
                   },
                   {
                       "name":  "Hobellattenzaun_12A",
                       "variante":  "12A",
                       "breite_cm":  6.5,
                       "anzahl_pro_m":  9,
                       "form":  "Quader",
                       "material":  "Fichte"
                   },
                   {
                       "name":  "Knueppelzaun_1R",
                       "variante":  "1R",
                       "breite_cm":  3.5,
                       "anzahl_pro_m":  12,
                       "form":  "Zylinder",
                       "material":  "Fichte"
                   },
                   {
                       "name":  "Quadratzaun_Laerche_32A",
                       "variante":  "32A",
                       "breite_cm":  3.6,
                       "anzahl_pro_m":  12,
                       "form":  "Quader",
                       "material":  "Laerche"
                   },
                   {
                       "name":  "Senkrechter_Lattenzaun_2C",
                       "variante":  "2C",
                       "breite_cm":  6.4,
                       "anzahl_pro_m":  9,
                       "form":  "halbrund",
                       "material":  "Fichte"
                   },
                   {
                       "name":  "Senkrechter_Lattenzaun_3E",
                       "variante":  "3E",
                       "breite_cm":  6.4,
                       "anzahl_pro_m":  9,
                       "form":  "halbrund",
                       "material":  "Fichte"
                   }
               ],
    "latten_artikel":  [
                           {
                               "sku":  "Hobellattenzaun_12A_60",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  60,
                               "preis":  2.613,
                               "gewicht_kg":  0.44
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_70",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  70,
                               "preis":  2.977,
                               "gewicht_kg":  0.51
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_80",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  80,
                               "preis":  3.25,
                               "gewicht_kg":  0.59
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_90",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  90,
                               "preis":  3.51,
                               "gewicht_kg":  0.66
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_100",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  100,
                               "preis":  3.77,
                               "gewicht_kg":  0.73
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_110",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  110,
                               "preis":  4.082,
                               "gewicht_kg":  0.81
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_120",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  120,
                               "preis":  4.524,
                               "gewicht_kg":  0.88
                           },
                           {
                               "sku":  "Knueppelzaun_1R_60",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  60,
                               "preis":  2.392,
                               "gewicht_kg":  0.27
                           },
                           {
                               "sku":  "Knueppelzaun_1R_70",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  70,
                               "preis":  2.509,
                               "gewicht_kg":  0.32
                           },
                           {
                               "sku":  "Knueppelzaun_1R_80",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  80,
                               "preis":  2.756,
                               "gewicht_kg":  0.36
                           },
                           {
                               "sku":  "Knueppelzaun_1R_90",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  90,
                               "preis":  2.938,
                               "gewicht_kg":  0.41
                           },
                           {
                               "sku":  "Knueppelzaun_1R_100",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  100,
                               "preis":  3.068,
                               "gewicht_kg":  0.45
                           },
                           {
                               "sku":  "Knueppelzaun_1R_110",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  110,
                               "preis":  3.224,
                               "gewicht_kg":  0.5
                           },
                           {
                               "sku":  "Knueppelzaun_1R_120",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  120,
                               "preis":  3.458,
                               "gewicht_kg":  0.54
                           },
                           {
                               "sku":  "Knueppelzaun_1R_130",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  130,
                               "preis":  3.718,
                               "gewicht_kg":  0.59
                           },
                           {
                               "sku":  "Knueppelzaun_1R_140",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  140,
                               "preis":  3.965,
                               "gewicht_kg":  0.63
                           },
                           {
                               "sku":  "Knueppelzaun_1R_150",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  150,
                               "preis":  4.238,
                               "gewicht_kg":  0.68
                           },
                           {
                               "sku":  "Quadratzaun_4K_60",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  60,
                               "preis":  2.613,
                               "gewicht_kg":  0.35
                           },
                           {
                               "sku":  "Quadratzaun_4K_70",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  70,
                               "preis":  2.834,
                               "gewicht_kg":  0.4
                           },
                           {
                               "sku":  "Quadratzaun_4K_80",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  80,
                               "preis":  3.042,
                               "gewicht_kg":  0.46
                           },
                           {
                               "sku":  "Quadratzaun_4K_90",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  90,
                               "preis":  3.549,
                               "gewicht_kg":  0.52
                           },
                           {
                               "sku":  "Quadratzaun_4K_100",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  100,
                               "preis":  3.614,
                               "gewicht_kg":  0.58
                           },
                           {
                               "sku":  "Quadratzaun_4K_110",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  110,
                               "preis":  4.186,
                               "gewicht_kg":  0.63
                           },
                           {
                               "sku":  "Quadratzaun_4K_120",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  120,
                               "preis":  4.42,
                               "gewicht_kg":  0.69
                           },
                           {
                               "sku":  "Quadratzaun_4K_130",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  130,
                               "preis":  5.122,
                               "gewicht_kg":  0.75
                           },
                           {
                               "sku":  "Quadratzaun_4K_140",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  140,
                               "preis":  5.317,
                               "gewicht_kg":  0.81
                           },
                           {
                               "sku":  "Quadratzaun_4K_150",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  150,
                               "preis":  5.733,
                               "gewicht_kg":  0.86
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_60",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  60,
                               "preis":  3.562,
                               "gewicht_kg":  0.46
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_70",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  70,
                               "preis":  3.77,
                               "gewicht_kg":  0.54
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_80",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  80,
                               "preis":  3.991,
                               "gewicht_kg":  0.61
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_90",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  90,
                               "preis":  4.784,
                               "gewicht_kg":  0.69
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_100",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  100,
                               "preis":  4.836,
                               "gewicht_kg":  0.76
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_110",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  110,
                               "preis":  5.421,
                               "gewicht_kg":  0.84
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_120",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  120,
                               "preis":  5.668,
                               "gewicht_kg":  0.92
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_130",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  130,
                               "preis":  6.357,
                               "gewicht_kg":  0.99
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_140",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  140,
                               "preis":  6.487,
                               "gewicht_kg":  1.07
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_150",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  150,
                               "preis":  6.968,
                               "gewicht_kg":  1.15
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_60",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  60,
                               "preis":  1.937,
                               "gewicht_kg":  0.45
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_70",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  70,
                               "preis":  1.963,
                               "gewicht_kg":  0.53
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_80",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  80,
                               "preis":  1.989,
                               "gewicht_kg":  0.6
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_90",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  90,
                               "preis":  2.184,
                               "gewicht_kg":  0.68
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_100",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  100,
                               "preis":  2.262,
                               "gewicht_kg":  0.76
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_110",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  110,
                               "preis":  2.613,
                               "gewicht_kg":  0.83
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_120",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  120,
                               "preis":  2.743,
                               "gewicht_kg":  0.91
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_130",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  130,
                               "preis":  3.146,
                               "gewicht_kg":  0.98
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_140",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  140,
                               "preis":  3.562,
                               "gewicht_kg":  1.06
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_150",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  150,
                               "preis":  3.822,
                               "gewicht_kg":  1.13
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_60",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  60,
                               "preis":  1.963,
                               "gewicht_kg":  0.45
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_70",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  70,
                               "preis":  2.145,
                               "gewicht_kg":  0.53
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_80",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  80,
                               "preis":  2.158,
                               "gewicht_kg":  0.6
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_90",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  90,
                               "preis":  2.223,
                               "gewicht_kg":  0.68
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_100",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  100,
                               "preis":  2.366,
                               "gewicht_kg":  0.76
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_110",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  110,
                               "preis":  2.756,
                               "gewicht_kg":  0.83
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_120",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  120,
                               "preis":  2.834,
                               "gewicht_kg":  0.91
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_130",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  130,
                               "preis":  3.289,
                               "gewicht_kg":  0.98
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_140",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  140,
                               "preis":  3.718,
                               "gewicht_kg":  1.06
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_150",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  150,
                               "preis":  3.9,
                               "gewicht_kg":  1.13
                           }
                       ],
    "riegel_artikel":  [
                           {
                               "sku":  "Querriegel_B_100",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  100,
                               "preis":  4.251,
                               "gewicht_kg":  1.43
                           },
                           {
                               "sku":  "Querriegel_B_200",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  200,
                               "preis":  8.489,
                               "gewicht_kg":  2.86
                           },
                           {
                               "sku":  "Querriegel_B_230",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  230,
                               "preis":  9.763,
                               "gewicht_kg":  3.29
                           },
                           {
                               "sku":  "Querriegel_B_250",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  250,
                               "preis":  10.621,
                               "gewicht_kg":  3.57
                           },
                           {
                               "sku":  "Querriegel_B_300",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  300,
                               "preis":  12.74,
                               "gewicht_kg":  4.29
                           },
                           {
                               "sku":  "Querriegel_B_400",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  400,
                               "preis":  20.072,
                               "gewicht_kg":  5.72
                           },
                           {
                               "sku":  "Querriegel_B_500",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  500,
                               "preis":  25.103,
                               "gewicht_kg":  7.15
                           },
                           {
                               "sku":  "Vierkantriegel_A_100",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  100,
                               "preis":  5.798,
                               "gewicht_kg":  1.41
                           },
                           {
                               "sku":  "Vierkantriegel_A_200",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  200,
                               "preis":  11.583,
                               "gewicht_kg":  2.82
                           },
                           {
                               "sku":  "Vierkantriegel_A_230",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  230,
                               "preis":  13.325,
                               "gewicht_kg":  3.24
                           },
                           {
                               "sku":  "Vierkantriegel_A_250",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  250,
                               "preis":  14.482,
                               "gewicht_kg":  3.52
                           },
                           {
                               "sku":  "Vierkantriegel_A_300",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  300,
                               "preis":  17.381,
                               "gewicht_kg":  4.23
                           },
                           {
                               "sku":  "Vierkantriegel_A_400",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  400,
                               "preis":  27.794,
                               "gewicht_kg":  5.64
                           },
                           {
                               "sku":  "Vierkantriegel_A_500",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  500,
                               "preis":  34.749,
                               "gewicht_kg":  7.05
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_50",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  50,
                               "preis":  5.395,
                               "gewicht_kg":  1.22
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_100",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  100,
                               "preis":  10.803,
                               "gewicht_kg":  2.43
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_150",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  150,
                               "preis":  16.211,
                               "gewicht_kg":  3.65
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_200",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  200,
                               "preis":  21.619,
                               "gewicht_kg":  4.87
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_220",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  220,
                               "preis":  23.777,
                               "gewicht_kg":  5.35
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_230",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  230,
                               "preis":  24.869,
                               "gewicht_kg":  5.6
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_240",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  240,
                               "preis":  25.948,
                               "gewicht_kg":  5.84
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_250",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  250,
                               "preis":  27.027,
                               "gewicht_kg":  6.08
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_300",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  300,
                               "preis":  32.435,
                               "gewicht_kg":  7.3
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_400",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  400,
                               "preis":  43.238,
                               "gewicht_kg":  9.73
                           }
                       ]
};
